import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { MerchantAccount, MerchantAccountListItem, InvalidMerchantAccount } from '../models';

@Injectable()
export class MerchantAccountService {
    private readonly apiUrl = `api/merchantaccount`;
    constructor(private readonly httpClient: HttpClient) { }

    getMyMerchantAccounts(): Observable<MerchantAccountListItem[]> {
        return this.httpClient.get<MerchantAccountListItem[]>(`${this.apiUrl}`);
    }

    getAllMerchantAccounts(): Observable<MerchantAccountListItem[]> {
        return this.httpClient.get<MerchantAccountListItem[]>(`${this.apiUrl}/All`);
    }

    getStandardAccounts(): Observable<MerchantAccountListItem[]> {
        return this.httpClient.get<MerchantAccountListItem[]>(`${this.apiUrl}/Standard`);
    }

    getCashnetAccounts(): Observable<MerchantAccountListItem[]> {
        return this.httpClient.get<MerchantAccountListItem[]>(`${this.apiUrl}/Cashnet`);
    }

    getInvalidMerchantAccounts(): Observable<InvalidMerchantAccount[]> {
        return this.httpClient.get<InvalidMerchantAccount[]>(`${this.apiUrl}/Invalid`);
    }

    getMerchantAccount(id: number): Observable<MerchantAccount> {
        return this.httpClient.get<MerchantAccount>(`${this.apiUrl}/${id}`);
    }

    getMerchantAccountIdByPackageId(packageId: number): Observable<number> {
        return this.httpClient.get<number>(`${this.apiUrl}/PackageId/${packageId}`);
    }

    isMerchantAccountNameUnique(name: string, id: number = null): Observable<boolean> {
        return this.httpClient.post<boolean>(`${this.apiUrl}/Name/Unique`, { merchantAccountId: id, merchantAccountName: name });
    }

    isMerchantIdUnique(merchantId: string, id: number = null): Observable<boolean> {
        return this.httpClient.post<boolean>(`${this.apiUrl}/MerchantID/Unique`, { merchantAccountId: id, merchantId: merchantId });
    }

    createAsDraft(request: any): Observable<number> {
        return this.httpClient.post<number>(`${this.apiUrl}/Create/Draft`, request);
    }

    updateAsDraft(request: any, id: number): Observable<void> {
        return this.httpClient.post<void>(`${this.apiUrl}/Update/${id}/Draft`, request);
    }

    createAndSubmit(request: any): Observable<number> {
        return this.httpClient.post<number>(`${this.apiUrl}/Create/Submit`, request);
    }

    updateAndSubmit(request: any, id: number): Observable<void> {
        return this.httpClient.post<void>(`${this.apiUrl}/Update/${id}/Submit`, request);
    }

    updateAndRestart(request: any, id: number): Observable<void> {
        return this.httpClient.post<void>(`${this.apiUrl}/Update/${id}/Restart`, request);
    }

    update(request: any, id: number): Observable<void> {
        return this.httpClient.post<void>(`${this.apiUrl}/Update/${id}`, request);
    }

    inactivate(id: number): Observable<void> {
        return this.httpClient.post<void>(`${this.apiUrl}/Inactivate/${id}`, null);
    }

    activate(id: number): Observable<void> {
        return this.httpClient.post<void>(`${this.apiUrl}/Activate/${id}`, null);
    }

    delete(id: number): Observable<void> {
        return this.httpClient.post<void>(`${this.apiUrl}/Delete/${id}`, null);
    }

    setMerchantId(request: any, id: number): Observable<void> {
        return this.httpClient.post<void>(`${this.apiUrl}/SetMerchantID/${id}`, request);
    }
}